import React, { Component } from 'react';
import { Row, Col, Button, Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import './style.css';
class downloadApk extends Component {
    

    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        return (
            <Container>
                <Row>
                    <Col className="downloadApk">
                        {countryCode.countryCode==="gr" ?
                          <div className="downloadApk-col">
                            <div>
                                <img src={require('./../../../assets/apks/mergemultiplepdf.png')} alt="" />
                                <h1><FormattedMessage id="main.downloadApk.title"
                                  defaultMessage="PDF Merger"
                                  description=""
                                  values="" /></h1>
                                <div className="downloadApk-margin-top">
                                    <a href="./../../assets/apks/mergemultiplepdf.apk" download><Button outline className="downloadApk-btn">
                                      <FormattedMessage id="main.downloadApk.button"
                                          defaultMessage="Λήψη"
                                          description=""
                                          values="" /></Button></a>
                                </div>
                            </div>
                            <div>
                                <img src={require('./../../../assets/apks/qrscanner.png')} alt="" />
                                <h1><FormattedMessage id="main.downloadApk.title"
                                  defaultMessage="QR Scanner"
                                  description=""
                                  values="" /></h1>
                                <div className="downloadApk-margin-top">
                                    <a href="./../../assets/apks/qrscanner.apk" download><Button outline className="downloadApk-btn">
                                      <FormattedMessage id="main.downloadApk.button"
                                          defaultMessage="Λήψη"
                                          description=""
                                          values="" /></Button></a>
                                </div>
                            </div>
                          </div>
                        : <div className="downloadApk-bg">
                            <div>
                                <h1><FormattedMessage id="main.downloadApk.title"
                                    defaultMessage="Aplikacja Face"
                                    description=""
                                    values="" /></h1>
                                <p className={countryCode.countryCode==="nl" ? "downloadApk-bg-p":null}><FormattedMessage id="main.downloadApk.paragraph"
                                    defaultMessage="Najbardziej zaawansowaną neuronową technologię edycji portretów."
                                    description=""
                                    values="" />
                                </p>
                                <div className="downloadApk-margin-top">
                                    <a href="./../../assets/FaceApp.apk" download><Button outline className="downloadApk-btn">
                                        <FormattedMessage id="main.downloadApk.button"
                                            defaultMessage="Pobierz aplikację"
                                            description=""
                                            values="" /></Button></a>
                                </div>
                            </div>
                          </div>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default downloadApk;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/DownloadApk/downloadApk.js